<div class="d-flex" id="wrapper">
<app-sidebar></app-sidebar>
<div id="page-content-wrapper">
<app-navbar></app-navbar>
<router-outlet></router-outlet>
</div>
</div>